import React from "react";
import UtilizationEntry from "./UtilizationEntry";

function MaskedUtilizationEntry({rank, value, isSelf}) {
    
    /* we should not be receiving the name from the api, but we will mask it anyway for safety.
        If the user is "self" the name will be displayed. */

    return (
        <UtilizationEntry rank={rank} name={"- - -"} value={value} isHighlighted={isSelf} />
    );

}

export default MaskedUtilizationEntry;